import React,{FunctionComponent} from "react";
import "./button.scss";
import { playMenuOver, playClicked } from "../../Sounds/Sounds";
type ButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    href?: string
    className?: string
    sameWindow?: boolean
    download?: boolean
};

const Button: FunctionComponent<ButtonProps> = ({children, className,href,sameWindow,download, ...props}) =>{

    if (href) {
        return (
           <a className={`button ${className}`} download={download} href={href} target={sameWindow ? "" : "blank"} {...props as any} onMouseEnter={() =>{playMenuOver()}} onClick={() =>{playClicked()}}>{children}</a>
        );
    } else {
        return (
            <button className={`button ${className}`} {...props} onMouseEnter={() =>{playMenuOver()}} onClick={(event) =>{playClicked();props.onClick?.(event);}}>{children}</button>
        );
    }
}
export default Button